import Add from './Add';
import ActualSize from './ActualSize';
import Adjust from './Adjust';
import AiStar from './AiStar';
import AlignItemBottom from './AlignItemBottom';
import AlignItemLeft from './AlignItemLeft';
import AlignItemRight from './AlignItemRight';
import AlignItemTop from './AlignItemTop';
import Attachment from './Attachment';
import Bang from './Bang';
import BlastRadius from './BlastRadius';
import Branch from './Branch';
import Close from './Close';
import Check from './Check';
import CheckboxCircle from './CheckboxCircle';
import CheckboxOff from './CheckboxOff';
import CheckboxOn from './CheckboxOn';
import Chat from './Chat';
import ChatNew from './ChatNew';
import Circle from './Circle';
import Clear from './Clear';
import Code from './Code';
import Component from './Component';
import Content from './Content';
import Connected from './Connected';
import Copy from './Copy';
import Create from './Create';
import DesignGenOff from './DesignGenOff';
import DesignGenOn from './DesignGenOn';
import Desktop from './Desktop';
import Diff from './Diff';
import Div from './Div';
import Dot from './Dot';
import DownALevel from './DownALevel';
import DragHandle from './DragHandle';
import Edit from './Edit';
import Edit1 from './Edit1';
import Edit2 from './Edit2';
import Empty from './Empty';
import Error from './Error';
import External from './External';
import ExternalFrame from './ExternalFrame';
import Eyedropper from './Eyedropper';
import Eye from './Eye';
import File from './File';
import FilledArrowDown from './FilledArrowDown';
import FilledArrowLeft from './FilledArrowLeft';
import FilledArrowRight from './FilledArrowRight';
import Folder from './Folder';
import Fragment from './Fragment';
import Frame from './Frame';
import Friendly from './Friendly';
import Fullscreen from './Fullscreen';
import Generate from './Generate';
import Globe from './Globe';
import Grid from './Grid';
import Hand from './Hand';
import History from './History';
import Home from './Home';
import Html from './Html';
import Controls from './Controls';
import Import from './Import';
import Information from './Information';
import Insert from './Insert';
import Interaction from './Interaction';
import Iterator from './Iterator';
import Layout from './Layout';
import LeftPaneHidden from './LeftPaneHidden';
import LeftPaneVisible from './LeftPaneVisible';
import LeftPane2Hidden from './LeftPane2Hidden';
import LeftPane2Visible from './LeftPane2Visible';
import LineArrowDown from './LineArrowDown';
import LineArrowLeft from './LineArrowLeft';
import LineArrowRight from './LineArrowRight';
import LineArrowUp from './LineArrowUp';
import Lock from './Lock';
import LockUnlocked from './LockUnlocked';
import LoopRight from './LoopRight';
import Maximize from './Maximize';
import Menu from './Menu';
import Merge from './Merge';
import Minimize from './Minimize';
import Mobile from './Mobile';
import Moonchild from './Moonchild';
import More from './More';
import More2 from './More2';
import Number from './Number';
import OpenExternal from './OpenExternal';
import OperatorAnd from './OperatorAnd';
import OperatorNullishCoalescing from './OperatorNullishCoalescing';
import OperatorOr from './OperatorOr';
import Panels from './Panels';
import Pause from './Pause';
import Place from './Place';
import Play from './Play';
import Prototype from './Prototype';
import Rectangle from './Rectangle';
import Reference from './Reference';
import Redo from './Redo';
import Refresh from './Refresh';
import Regularize from './Regularize';
import ResetView from './ResetView';
import Restore from './Restore';
import RightPanelHidden from './RightPanelHidden';
import RightPanelVisible from './RightPanelVisible';
import Respawn from './Respawn';
import Search from './Search';
import Select from './Select';
import Settings from './Settings';
import Shadow from './Shadow';
import Share from './Share';
import Shuffle from './Shuffle';
import Star from './Star';
import StarOutline from './StarOutline';
import Shining from './Shining';
import ShiningOutline from './ShiningOutline';
import Stop from './Stop';
import Style from './Style';
import Sun from './Sun';
import Sync from './Sync';
import Tablet from './Tablet';
import Ternary from './Ternary';
import TestDrive from './TestDrive';
import Text from './Text';
import Time from './Time';
import ToggleOff from './ToggleOff';
import ToggleOn from './ToggleOn';
import TopmostLevel from './TopmostLevel';
import Unknown from './Unknown';
import UpALevel from './UpALevel';
import Upload from './Upload';
import Upload2 from './Upload2';
import User from './User';
import Undo from './Undo';
import Variable from './Variable';
import VersionControl from './VersionControl';
import VolumeMute from './VolumeMute';
import VolumeUp from './VolumeUp';
import ZoomIn from './ZoomIn';
import ZoomOut from './ZoomOut';

import { step } from 'tokens';
import { useTheme } from 'styled-components';

// Different kinds of icon types that can be used
export enum IconType {
	ADD = 1,
	ACTUAL_SIZE,
	ADJUST,
	AI_STAR,
	ALIGN_ITEM_BOTTOM,
	ALIGN_ITEM_LEFT,
	ALIGN_ITEM_RIGHT,
	ALIGN_ITEM_TOP,
	ATTACHMENT,
	BANG,
	BLAST_RADIUS,
	BRANCH,
	CHECK,
	CHECKBOX_CIRCLE,
	CHECKBOX_OFF,
	CHECKBOX_ON,
	CHAT,
	CHAT_NEW,
	CIRCLE,
	CLOSE,
	CLEAR,
	CODE,
	COMPONENT,
	CONNECTED,
	CONTENT,
	COPY,
	CONTROLS,
	CREATE,
	DESIGN_GEN_OFF,
	DESIGN_GEN_ON,
	DESKTOP,
	DIFF,
	DIV,
	DOT,
	DOWN_A_LEVEL,
	DRAG_HANDLE,
	EDIT,
	EDIT1,
	EDIT2,
	EMPTY,
	ERROR,
	EXTERNAL,
	EXTERNAL_FRAME,
	EYE,
	EYEDROPPER,
	FILE,
	FILLED_ARROW_DOWN,
	FILLED_ARROW_LEFT,
	FILLED_ARROW_RIGHT,
	FOLDER,
	FRAGMENT,
	FRAME,
	FRIENDLY,
	FULLSCREEN,
	GENERATE,
	GLOBE,
	GRID,
	HAND,
	HISTORY,
	HOME,
	HTML,
	IMPORT,
	INFORMATION,
	INSERT,
	INTERACTION,
	ITERATOR,
	LAYOUT,
	LEFT_PANE_HIDDEN,
	LEFT_PANE_VISIBLE,
	LEFT_PANE2_HIDDEN,
	LEFT_PANE2_VISIBLE,
	LINE_ARROW_DOWN,
	LINE_ARROW_LEFT,
	LINE_ARROW_RIGHT,
	LINE_ARROW_UP,
	LOCK,
	LOCK_UNLOCKED,
	LOOP_RIGHT,
	MAXIMIZE,
	MENU,
	MERGE,
	MIGHTY_MELD,
	MINIMIZE,
	MOBILE,
	MOONCHILD,
	MORE,
	MORE2,
	NUMBER,
	OPEN_EXTERNAL,
	OPERATOR_AND,
	OPERATOR_NULLISH_COALESCING,
	OPERATOR_OR,
	PANELS,
	PAUSE,
	PLACE,
	PLAY,
	PROTOTYPE,
	RECTANGLE,
	REDO,
	REFERENCE,
	REFRESH,
	REGULARIZE,
	RESET_VIEW,
	RESTORE,
	RIGHT_PANE_HIDDEN,
	RIGHT_PANE_VISIBLE,
	RESPAWN,
	SEARCH,
	SELECT,
	SETTINGS,
	SHADOW,
	SHARE,
	SHUFFLE,
	STAR,
	STAR_OUTLINE,
	SHINING,
	SHINING_OUTLINE,
	STOP,
	STYLE,
	SUN,
	SYNC,
	TABLET,
	TERNARY,
	TEST_DRIVE,
	TEXT,
	TIME,
	TOGGLE_OFF,
	TOGGLE_ON,
	TOPMOST_LEVEL,
	UNDO,
	UNKNOWN,
	UPLOAD,
	UPLOAD2,
	UP_A_LEVEL,
	VARIABLE,
	VERSION_CONTROL,
	USER,
	VOLUME_MUTE,
	VOLUME_UP,
	ZOOM_IN,
	ZOOM_OUT,
}

interface IconProps {
	type: IconType;
	color?: string;
	width?: number;
	height?: number;
}

const Icon = ({ type, color, width, height }: IconProps) => {
	const theme = useTheme();

	const props = {
		color: color ? color : theme.gray['900'],
		width: width ? width : 3 * step,
		height: height ? height : 3 * step,
	};

	switch (type) {
		case IconType.ADD:
			return <Add {...props} />;
		case IconType.ACTUAL_SIZE:
			return <ActualSize {...props} />;
		case IconType.ADJUST:
			return <Adjust {...props} />;
		case IconType.AI_STAR:
			return <AiStar {...props} />;
		case IconType.ALIGN_ITEM_BOTTOM:
			return <AlignItemBottom {...props} />;
		case IconType.ALIGN_ITEM_LEFT:
			return <AlignItemLeft {...props} />;
		case IconType.ALIGN_ITEM_RIGHT:
			return <AlignItemRight {...props} />;
		case IconType.ALIGN_ITEM_TOP:
			return <AlignItemTop {...props} />;
		case IconType.ATTACHMENT:
			return <Attachment {...props} />;
		case IconType.BANG:
			return <Bang {...props} />;
		case IconType.BLAST_RADIUS:
			return <BlastRadius {...props} />;
		case IconType.BRANCH:
			return <Branch {...props} />;
		case IconType.CHAT:
			return <Chat {...props} />;
		case IconType.CHAT_NEW:
			return <ChatNew {...props} />;
		case IconType.CHECK:
			return <Check {...props} />;
		case IconType.CHECKBOX_CIRCLE:
			return <CheckboxCircle {...props} />;
		case IconType.CHECKBOX_OFF:
			return <CheckboxOff {...props} />;
		case IconType.CHECKBOX_ON:
			return <CheckboxOn {...props} />;
		case IconType.CIRCLE:
			return <Circle {...props} />;
		case IconType.CLEAR:
			return <Clear {...props} />;
		case IconType.CLOSE:
			return <Close {...props} />;
		case IconType.CODE:
			return <Code {...props} />;
		case IconType.COMPONENT:
			return <Component {...props} />;
		case IconType.CONNECTED:
			return <Connected {...props} />;
		case IconType.CONTENT:
			return <Content {...props} />;
		case IconType.CONTROLS:
			return <Controls {...props} />;
		case IconType.COPY:
			return <Copy {...props} />;
		case IconType.CREATE:
			return <Create {...props} />;
		case IconType.DESIGN_GEN_OFF:
			return <DesignGenOff {...props} />;
		case IconType.DESIGN_GEN_ON:
			return <DesignGenOn {...props} />;
		case IconType.DESKTOP:
			return <Desktop {...props} />;
		case IconType.DIFF:
			return <Diff {...props} />;
		case IconType.DIV:
			return <Div {...props} />;
		case IconType.DOWN_A_LEVEL:
			return <DownALevel {...props} />;
		case IconType.DOT:
			return <Dot {...props} />;
		case IconType.DRAG_HANDLE:
			return <DragHandle {...props} />;
		case IconType.EDIT:
			return <Edit {...props} />;
		case IconType.EDIT1:
			return <Edit1 {...props} />;
		case IconType.EDIT2:
			return <Edit2 {...props} />;
		case IconType.EMPTY:
			return <Empty {...props} />;
		case IconType.ERROR:
			return <Error {...props} />;
		case IconType.EXTERNAL:
			return <External {...props} />;
		case IconType.EXTERNAL_FRAME:
			return <ExternalFrame {...props} />;
		case IconType.EYE:
			return <Eye {...props} />;
		case IconType.EYEDROPPER:
			return <Eyedropper {...props} />;
		case IconType.FILE:
			return <File {...props} />;
		case IconType.FILLED_ARROW_DOWN:
			return <FilledArrowDown {...props} />;
		case IconType.FILLED_ARROW_LEFT:
			return <FilledArrowLeft {...props} />;
		case IconType.FILLED_ARROW_RIGHT:
			return <FilledArrowRight {...props} />;
		case IconType.FOLDER:
			return <Folder {...props} />;
		case IconType.FRAGMENT:
			return <Fragment {...props} />;
		case IconType.FRAME:
			return <Frame {...props} />;
		case IconType.FRIENDLY:
			return <Friendly {...props} />;
		case IconType.FULLSCREEN:
			return <Fullscreen {...props} />;
		case IconType.GENERATE:
			return <Generate {...props} />;
		case IconType.GLOBE:
			return <Globe {...props} />;
		case IconType.GRID:
			return <Grid {...props} />;
		case IconType.HAND:
			return <Hand {...props} />;
		case IconType.HISTORY:
			return <History {...props} />;
		case IconType.HOME:
			return <Home {...props} />;
		case IconType.HTML:
			return <Html {...props} />;
		case IconType.IMPORT:
			return <Import {...props} />;
		case IconType.INFORMATION:
			return <Information {...props} />;
		case IconType.INSERT:
			return <Insert {...props} />;
		case IconType.INTERACTION:
			return <Interaction {...props} />;
		case IconType.ITERATOR:
			return <Iterator {...props} />;
		case IconType.LAYOUT:
			return <Layout {...props} />;
		case IconType.LEFT_PANE_HIDDEN:
			return <LeftPaneHidden {...props} />;
		case IconType.LEFT_PANE_VISIBLE:
			return <LeftPaneVisible {...props} />;
		case IconType.LEFT_PANE2_HIDDEN:
			return <LeftPane2Hidden {...props} />;
		case IconType.LEFT_PANE2_VISIBLE:
			return <LeftPane2Visible {...props} />;
		case IconType.LINE_ARROW_DOWN:
			return <LineArrowDown {...props} />;
		case IconType.LINE_ARROW_LEFT:
			return <LineArrowLeft {...props} />;
		case IconType.LINE_ARROW_RIGHT:
			return <LineArrowRight {...props} />;
		case IconType.LINE_ARROW_UP:
			return <LineArrowUp {...props} />;
		case IconType.LOCK:
			return <Lock {...props} />;
		case IconType.LOCK_UNLOCKED:
			return <LockUnlocked {...props} />;
		case IconType.LOOP_RIGHT:
			return <LoopRight {...props} />;
		case IconType.MAXIMIZE:
			return <Maximize {...props} />;
		case IconType.MENU:
			return <Menu {...props} />;
		case IconType.MERGE:
			return <Merge {...props} />;
		case IconType.MINIMIZE:
			return <Minimize {...props} />;
		case IconType.MOBILE:
			return <Mobile {...props} />;
		case IconType.MOONCHILD:
			return <Moonchild {...props} />;
		case IconType.MORE:
			return <More {...props} />;
		case IconType.MORE2:
			return <More2 {...props} />;
		case IconType.NUMBER:
			return <Number {...props} />;
		case IconType.OPEN_EXTERNAL:
			return <OpenExternal {...props} />;
		case IconType.OPERATOR_AND:
			return <OperatorAnd {...props} />;
		case IconType.OPERATOR_NULLISH_COALESCING:
			return <OperatorNullishCoalescing {...props} />;
		case IconType.OPERATOR_OR:
			return <OperatorOr {...props} />;
		case IconType.PANELS:
			return <Panels {...props} />;
		case IconType.PAUSE:
			return <Pause {...props} />;
		case IconType.PLACE:
			return <Place {...props} />;
		case IconType.PLAY:
			return <Play {...props} />;
		case IconType.PROTOTYPE:
			return <Prototype {...props} />;
		case IconType.RECTANGLE:
			return <Rectangle {...props} />;
		case IconType.REFERENCE:
			return <Reference {...props} />;
		case IconType.REDO:
			return <Redo {...props} />;
		case IconType.RESPAWN:
			return <Respawn {...props} />;
		case IconType.REFRESH:
			return <Refresh {...props} />;
		case IconType.REGULARIZE:
			return <Regularize {...props} />;
		case IconType.RESET_VIEW:
			return <ResetView {...props} />;
		case IconType.RESTORE:
			return <Restore {...props} />;
		case IconType.RIGHT_PANE_HIDDEN:
			return <RightPanelHidden {...props} />;
		case IconType.RIGHT_PANE_VISIBLE:
			return <RightPanelVisible {...props} />;
		case IconType.SEARCH:
			return <Search {...props} />;
		case IconType.SELECT:
			return <Select {...props} />;
		case IconType.SETTINGS:
			return <Settings {...props} />;
		case IconType.SHADOW:
			return <Shadow {...props} />;
		case IconType.SHARE:
			return <Share {...props} />;
		case IconType.SHUFFLE:
			return <Shuffle {...props} />;
		case IconType.STAR:
			return <Star {...props} />;
		case IconType.STAR_OUTLINE:
			return <StarOutline {...props} />;
		case IconType.SHINING:
			return <Shining {...props} />;
		case IconType.SHINING_OUTLINE:
			return <ShiningOutline {...props} />;
		case IconType.STYLE:
			return <Style {...props} />;
		case IconType.STOP:
			return <Stop {...props} />;
		case IconType.SUN:
			return <Sun {...props} />;
		case IconType.SYNC:
			return <Sync {...props} />;
		case IconType.TABLET:
			return <Tablet {...props} />;
		case IconType.TERNARY:
			return <Ternary {...props} />;
		case IconType.TEST_DRIVE:
			return <TestDrive {...props} />;
		case IconType.TEXT:
			return <Text {...props} />;
		case IconType.TIME:
			return <Time {...props} />;
		case IconType.TOGGLE_OFF:
			return <ToggleOff {...props} />;
		case IconType.TOGGLE_ON:
			return <ToggleOn {...props} />;
		case IconType.TOPMOST_LEVEL:
			return <TopmostLevel {...props} />;
		case IconType.UNDO:
			return <Undo {...props} />;
		case IconType.UNKNOWN:
			return <Unknown {...props} />;
		case IconType.UPLOAD:
			return <Upload {...props} />;
		case IconType.UPLOAD2:
			return <Upload2 {...props} />;
		case IconType.UP_A_LEVEL:
			return <UpALevel {...props} />;
		case IconType.VARIABLE:
			return <Variable {...props} />;
		case IconType.VERSION_CONTROL:
			return <VersionControl {...props} />;
		case IconType.USER:
			return <User {...props} />;
		case IconType.VOLUME_MUTE:
			return <VolumeMute {...props} />;
		case IconType.VOLUME_UP:
			return <VolumeUp {...props} />;
		case IconType.ZOOM_IN:
			return <ZoomIn {...props} />;
		case IconType.ZOOM_OUT:
			return <ZoomOut {...props} />;
		default:
			console.warn('unrecognized Icon type: [' + type + ']');
			return null;
	}
};

export default Icon;
